import { createSlice } from "@reduxjs/toolkit";
import { IUserData } from "../shared/Interfaces";

export interface ILoginStore {
  authenticated: boolean;
  userInfo?: IUserData;
}

export const loginInitialState: ILoginStore = {
  authenticated: false,
  userInfo: undefined,
};

const loginSlice = createSlice({
  name: "login",
  initialState: loginInitialState,
  reducers: {
    login: (state, action) => {
      const { token, userData } = action.payload;
      //localStorage already set in API call.
      state.authenticated = token && userData ? true : false;
      state.userInfo = userData ? userData : undefined;
    },
    signup: (state, action) => {},
    logout: (state) => {
      state.authenticated = false;
      state.userInfo = undefined;
    },
  },
});

export const { login, logout } = loginSlice.actions;
export default loginSlice;
